import React, { useState } from 'react';
import Profile from './Profile';

const TableRow = ({ player, colSpan, offsetColSpan = 0, profileOpen }) => {
  if (!profileOpen || !player.profile) return null;

  return <tr className="row-profile profile-open">
    <td className="border-0">{/* rank */}</td>
    <td colSpan={colSpan} className="border-0">
      <Profile {...player} />
    </td>
    {offsetColSpan ? <td colSpan={offsetColSpan} className="border-0"></td> : null}
  </tr>
}

export { default as Profile } from './Profile';

export const ProfileRow = ({ colSpan, offsetColSpan, player, children, ...props }) => {
  const [ profileOpen, setOpen ] = useState(false);
  const toggle = () => {
    if (!player?.profile) return;
    setOpen(open => !open);
  }

  return <>
    { React.cloneElement(children, { ...props, player, profileOpen, toggle }) }
    <TableRow player={player} colSpan={colSpan} offsetColSpan={offsetColSpan} profileOpen={profileOpen} />
  </>
}
